import type { AnyRouter, RouterHistory } from '@tanstack/react-router'
import { createContext, useContext } from 'react'

/**
 * Quem cria o roteador de cada janela do Modo PC — F138.
 *
 * Um contexto, e não um `import` de `router.tsx`, porque o roteador importa a
 * moldura, a moldura importa a área de trabalho e a área de trabalho importaria
 * o roteador de volta. `main.tsx` fornece a fábrica; os testes podem fornecer
 * uma árvore pequena.
 *
 * O histórico vem junto, e tipado: é por ele que a área de trabalho leva uma
 * janela que já existe até um registro, e o `AnyRouter` não diz o tipo do
 * histórico que carrega.
 */
export type WindowRouter = {
  readonly router: AnyRouter
  readonly history: RouterHistory
}

export type WindowRouterFactory = (initialHref: string) => WindowRouter

export const WindowRouterFactoryContext =
  createContext<WindowRouterFactory | null>(null)

export const useWindowRouterFactory = (): WindowRouterFactory => {
  const factory = useContext(WindowRouterFactoryContext)
  if (factory === null) {
    throw new Error(
      'A área de trabalho precisa de WindowRouterFactoryContext (main.tsx).'
    )
  }
  return factory
}
